import LiveInputs from './../handlers/live_inputs'

onDomLoad(($dom) => {
  LiveInputs.initialize($dom)
})
